import React, { useState } from 'react';
import ExpandFieldBtn from '../ExpandFieldBtn';
import useGenericRows from '@/lib/hooks/useGenericRows';
import DataTable from '../DataTable';

export default function ExpandableField({
  title,
  data,
  canClose = true,
  defaultOpen = true,
  setOpen,
  contentWhenClosed = null,
}: {
  title?: string;
  data: any;
  defaultOpen?: boolean;
  canClose?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  contentWhenClosed?: string | null;
}) {
  console.log("Data", data);
  const directorData = data.data?.Credits?.Director || null;
  const actorData = data.data?.Credits?.Actor || null;




  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [attrOpenStates, setAttrOpenStates] = useState<any>(() => {
    const initialStates: any = {};
    // If you can find actor or director data, the corresponding field should be open by default -Matthew Li
    if (actorData !== null) initialStates.Actor = true;
    if (directorData !== null) initialStates.Director = true;
    return initialStates;
  });

  const tableRowData = useGenericRows(data, attrOpenStates, setAttrOpenStates);




  const handleToggle = () => {
    if (setOpen) {
      setOpen((prev) => !prev);
    } else {
      setIsOpen((prev) => !prev);
    }
  };

  return (
    <div className="expandable-field text-md w-full flex flex-col animate__animated animate__fadeIn">
      {canClose && (
        <div className="flex w-full justify-between my-2">
          <h4 className="text-lg">{title}</h4>
          <ExpandFieldBtn open={isOpen} setOpen={handleToggle} title={''} />
        </div>
      )}
      {isOpen && tableRowData ? (
        <div className="tableWrap p-4 border border-primary-light">
          <div className="w-full h-[1px]" />
          <DataTable tableRowData={tableRowData} data={data} />
        </div>
      ) : !isOpen && (<><hr /><div>{contentWhenClosed}</div></>)
      }
    </div>
  );
}
